export default "__VITE_ASSET__qUY6gCSV__"